import React from "react";
import { Grid, Card, Stack, Typography } from "@mui/joy";

interface StatsGridProps {
  stats: { label: string; value: number; icon: string }[];
}

const StatsGrid: React.FC<StatsGridProps> = ({ stats }) => (
  <Grid
    container
    sx={{
      display: "grid",
      gridTemplateColumns: {
        xs: "repeat(2, 1fr)",
        md: "repeat(3, 1fr)",
      },
      gap: 1.5,
    }}
  >
    {stats?.map((stat, index) => (
      <Card
        key={index}
        variant="soft"
        sx={{
          height: 144,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack spacing={1} alignItems="center">
          <img src={stat.icon} alt={stat.label} width={32} height={32} />
          <Typography level="dashboardHeading">{stat.value}</Typography>
          <Typography level="description">{stat.label}</Typography>
        </Stack>
      </Card>
    ))}
  </Grid>
);

export default StatsGrid;
